import React from 'react';
import { HStack } from '@gluestack-ui/themed';

type ReferenceFieldBoxProps = {
  children: React.ReactNode;
  focused?: boolean;
};

/**
 * The bordered box both reference fields share. Pills and the search sit inside it.
 */
const ReferenceFieldBox: React.FC<ReferenceFieldBoxProps> = ({
  children,
  focused = false,
}) => (
  <HStack
    testID="reference-field-box"
    alignItems="center"
    flexWrap="wrap"
    space="xs"
    borderWidth={1}
    borderColor={focused ? '$borderFocus' : '$borderLight'}
    borderRadius="$md"
    bg="$bgApp"
    px="$2"
    py="$1"
    minHeight={36}
  >
    {children}
  </HStack>
);

export default ReferenceFieldBox;
